import React, { useEffect } from "react";
import clsx from "clsx";
import { Link, useNavigate } from "react-router-dom";
import { TableCustom } from "@components";
// import PropTypes from "prop-types";
import styles from "./styles/MyCoursesTab.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCourseAction,
  // getMyCoursesAction,
  updateCourseActions,
} from "@redux/actions";
import moment from "moment";
import { ConfirmModal } from "@components/ConfirmModal/ConfirmModal";
import { replaceErrorImage } from "@helpers";
import { FilterLayout } from "../FilterLayout/FilterLayout";

const MyCoursesTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { myCourses } = useSelector((state) => state.instructorCourse);
  useEffect(() => {
    // dispatch(getMyCoursesAction({ IsActive: true }));
    dispatch(updateCourseActions.reset());
  }, []);

  const editCourse = (courseId) => {
    navigate(`/update-course/${courseId}`, {
      state: { isUpdate: true },
    });
  };

  const viewCourse = (courseId) => {
    navigate(`/course/${courseId}`);
  };

  // effects

  const columns = [
    {
      title: "Thumbnail",
      dataIndex: "thumbnailUrl",
      render: (thumbnail) => {
        return (
          <img
            src={thumbnail}
            alt={"thumbnail course"}
            style={{ width: "100px", height: "60px", objectFit: "cover" }}
            onError={replaceErrorImage}
          />
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Create Date",
      dataIndex: "createdAt",
      render: (publishDate) => {
        return (
          <div>{`${moment(publishDate)
            .add(7, "hours")
            .format("DD MMMM YYYY | HH:mm")}`}</div>
        );
      },
    },
    // {
    //   title: "Sales",
    //   dataIndex: "sale",
    // },
    // {
    //   title: "Parts",
    //   dataIndex: "parts",
    // },
    {
      title: "Category",
      dataIndex: "category",
      render: (category) => {
        return (
          <Link
            to={`/explore?CategoryId=${category.id}`}
            className="text-decoration-none"
          >
            {category.name}
          </Link>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      // dataIndex: "status",
      render: (status) => {
        switch (status) {
          case 0:
            return <strong className="text-info">Pending</strong>;
          case 1:
            return <strong className="text-success">Approved</strong>;
          case 2:
            return <strong className="text-warning">Rejected</strong>;
          case 3:
            return <strong className="text-danger">Blocked</strong>;

          default:
            break;
        }
      },
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id) => {
        return (
          <div>
            <i
              className={clsx("bi bi-eye mr-2", styles.icon)}
              onClick={() => {
                viewCourse(id);
              }}
            ></i>
            <i
              className={clsx("bi bi-pencil-square", styles.icon)}
              onClick={() => {
                editCourse(id);
              }}
            ></i>
            <ConfirmModal
              onSubmit={() => {
                dispatch(deleteCourseAction({ id: id, type: "course" }));
              }}
              title="Delete Course"
              submitButton="Delete"
              body="Are you sure to delete this course?"
            >
              <i className={clsx("bi bi-trash ml-2", styles.icon)}></i>
            </ConfirmModal>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <FilterLayout pagination={myCourses.pagination} isActive={true}>
        <TableCustom
          columns={columns}
          dataSource={myCourses.data}
          isLoading={myCourses.processing}
        />
      </FilterLayout>
    </>
  );
};

/* required: display name */
MyCoursesTab.displayName = "MyCoursesTab";

/* required: props types */
MyCoursesTab.propTypes = {};

/* required: default props */
MyCoursesTab.defaultProps = {};

export { MyCoursesTab };
